import React, { useState } from 'react'

import MultiSelectionDropdown from 'components/MultiSelectDropdown'

import { FiltersContentContainer } from '../style'
import qs from 'query-string'

export const getEcoRegionUrl = (ecoRegionList) => {
  return qs.stringify({
    ecoRegionId: ecoRegionList.toString()
  })
}

const EcologicalFiltersContent = ({ item, updateFilters, filterTitle, ecoregionOptions }) => {
  const [ecoregionList, setEcoregionList] = useState(item.ecoregionList)
  const [ecoregionQuery, setEcoregionQuery] = useState('')

  console.log(ecoregionOptions)

  const handleCHangeEcoregionList = (e) => {
    setEcoregionList(e)
    updateFilters({ ...item, ecoregionList: e, url: getEcoRegionUrl(e) }, filterTitle)
  }

  const handleChangeEcoregionQuery = (e) => {
    setEcoregionQuery(e)
  }

  return (
    <FiltersContentContainer>
      <MultiSelectionDropdown
        dataTest='Ecoregion'
        marginTop='16px'
        label='ecoregion'
        secondStepOptions={ecoregionOptions}
        value={ecoregionList}
        saveChanges={handleCHangeEcoregionList}
        infoTooltip='ecoregionFilterHint'
        inputValue={ecoregionQuery}
        onInputChange={handleChangeEcoregionQuery}
        isSearchable={true}
        placeholder='selectEcoregion'
        selectAllOption={true}
      />
    </FiltersContentContainer>
  )
}

export default EcologicalFiltersContent
